var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTopbar(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 1062.342,
    height: 158.193,
    viewBox: "0 0 1062.342 158.193",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_15333",
    "data-name": "Path 15333",
    d: "M-25.82,283.138S42.471,270.4,253.409,270.4s703.6,19.311,782.88,12.233L1036.522,126h-1062Z",
    transform: "translate(0 68.003)",
    fill: "#c70b0b"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.038,
    y1: 0.036,
    x2: 0.928,
    y2: 0.736,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#37e3a8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1c9d87"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Mask_Group_615",
    "data-name": "Mask Group 615",
    transform: "translate(25.82 -194)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_15332",
    "data-name": "Path 15332",
    d: "M0,0H1033V158.193H0Z",
    transform: "translate(-4 194)",
    fill: "url(#linear-gradient)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTopbar);
export default __webpack_public_path__ + "static/media/topbar.07cee23c5bab57e99281e4dceda6dfac.svg";
export { ForwardRef as ReactComponent };